import { GoodTicketCode } from 'types/tickets'

import { EventPolicy } from 'meta/backendControlled/structure'
import { ITicket } from 'meta/pages/tickets'

export const getTicketFieldsKey = (ticket: ITicket, idx: number): string => `${ticket.id}_${idx}`

export const scrollToTicket = (ticket: ITicket, idx: number): void => {
  const ticketElement = document.getElementById(`${idx}_${ticket.id}`)
  document.documentElement.scrollTo({
    top: ticketElement?.offsetTop,
    behavior: 'smooth',
  })
}

export const checkIfTransactionIsGoodsRelated = (code: string): boolean => {
  return ![EventPolicy.covid19, EventPolicy.default, EventPolicy.seasonEvent].includes(
    code as EventPolicy & GoodTicketCode
  )
}
